import React from 'react';
import { MapPin } from 'lucide-react';
import { useLocale } from '../../contexts/LocaleContext';
import { colors } from '../../config/colors';

export default function LandingGlobalSentimentLegend() {
  const { t } = useLocale();

  const sentimentItems = [
    { labelKey: 'landingSentimentLegendPositive', color: colors.success[500] },
    { labelKey: 'landingSentimentLegendNeutral', color: colors.warning[500] },
    { labelKey: 'landingSentimentLegendNegative', color: colors.danger[500] },
  ];

  const riskItems = [
    { labelKey: 'landingRiskMarkerHigh', color: colors.danger[500] },
    { labelKey: 'landingRiskMarkerMedium', color: colors.warning[500] },
    { labelKey: 'landingRiskMarkerLow', color: colors.success[500] },
  ];

  return (
    <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
      <div>
        <p className="mb-2 text-xs font-medium uppercase tracking-wide text-text-tertiary">
          {t('landingSentimentLegendTitle')}
        </p>
        <div className="flex flex-wrap gap-x-4 gap-y-2">
          {sentimentItems.map(({ labelKey, color }) => (
            <div key={labelKey} className="flex items-center gap-2 text-xs text-text-secondary">
              <span className="size-3 rounded-sm" style={{ backgroundColor: color }} />
              <span>{t(labelKey)}</span>
            </div>
          ))}
        </div>
      </div>
      <div>
        <p className="mb-2 text-xs font-medium uppercase tracking-wide text-text-tertiary">
          {t('landingRiskMarkerLegendTitle')}
        </p>
        <div className="flex flex-wrap gap-x-4 gap-y-2">
          {riskItems.map(({ labelKey, color }) => (
            <div key={labelKey} className="flex items-center gap-2 text-xs text-text-secondary">
              <MapPin className="size-3.5" style={{ color }} aria-hidden />
              <span>{t(labelKey)}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
